import React, {useContext} from "react";
import {WizardContext} from "../context";
import {useStyles} from "../styles";
import {Button, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography, IconButton} from "@material-ui/core";
import {RemoveCircle as RemoveCircleIcon} from '@material-ui/icons';
import {RESPONSE_TYPE} from "../constants";

const WizardStep3 = () => {
  const {formData, fieldChange} = useContext(WizardContext);
  const classes = useStyles();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch' }}>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <FormControl className={classes.formControl}>
          <Typography id="campaign-question" gutterBottom>
            {formData.campaignType === 'coupon' ? 'Coupon description' : 'Campaign Question'} (max 500 characters)
          </Typography>
          <TextField
            id='campaign-question'
            label={`${formData.campaignType === 'coupon' ? 'Coupon Description' : 'Question'} that users will see`}
            multiline
            rows={3}
            rowsMax={8}
            fullWidth
            value={formData.questionText}
            onChange={fieldChange('questionText')}
          />
          <Typography className={classes.radioGroupLabel}>
            {formData.questionText.length} Characters
          </Typography>
        </FormControl>

        {formData.campaignType !== 'coupon' && (
          <>
            <FormControl className={classes.formControl}>
              <Typography id="campaign-type" gutterBottom>
                Choose response type
              </Typography>
              <RadioGroup name='response-type' value={formData.responseType} onChange={fieldChange('responseType')}>
                {Object.keys(RESPONSE_TYPE).map(campaignType => (
                  <FormControlLabel
                    key={campaignType}
                    control={<Radio color='primary' />}
                    value={campaignType}
                    label={<Typography className={classes.radioGroupLabel}>{RESPONSE_TYPE[campaignType]}</Typography>}
                    labelPlacement='end'
                  />
                ))}
              </RadioGroup>
            </FormControl>
            {formData.responseType.indexOf('multi') > -1 && (
              <FormControl className={classes.formControl}>
                <Typography id="campaign-options" gutterBottom>
                  Add answer options (max 10)
                </Typography>
                {formData.responseOptions && formData.responseOptions.map((response, index) => (
                  <TextField
                    key={index}
                    fullWidth
                    label={`Response Option ${index + 1}`}
                    value={formData.responseOptions[index].name}
                    onChange={({target: { value }}) => {
                      const options = [...formData.responseOptions];
                      options[index].name = value;
                      fieldChange('responseOptions')({target: { value: options }});
                    }}
                    InputProps={{
                      endAdornment: formData.responseOptions.length > 2 && (
                        <IconButton onClick={() => {
                          const options = [...formData.responseOptions];
                          options.splice(index, 1);
                          fieldChange('responseOptions')({target: { value: options }});
                        }}>
                          <RemoveCircleIcon />
                        </IconButton>
                      )
                    }}
                  />
                ))}
                <Button size='small' color='secondary' onClick={() => {
                  if (formData.responseOptions.length >= 10) return;
                  const options = [...formData.responseOptions];
                  options.push({name: ''});
                  fieldChange('responseOptions')({target: { value: options }});
                }}>
                  Add New Option
                </Button>
              </FormControl>
            )}
          </>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <FormControl className={classes.formControl}>
          <Typography id="campaign-image" gutterBottom>
            Add an image?
          </Typography>
          <input
            accept="image/*"
            className={classes.fileInput}
            id="raised-button-file"
            multiple
            type="file"
            onChange={({target: { files }}) => {
              fieldChange('campaignImage')({target: { value: files[0]}});
            }}
          />
          <label htmlFor="raised-button-file">
            <Button raised component="span" color='secondary' className={classes.button}>
              Choose Image File
            </Button>
          </label>
          {formData.campaignImage && (
            <p>
              <img
                height={300}
                alt='Campaign'
                src={URL.createObjectURL(formData.campaignImage)}
              />
            </p>
          )}
        </FormControl>
      </div>
    </div>
  )
};

export default WizardStep3;
